var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarks1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks_-_1",
    "data-name": "Bookmarks - 1",
    transform: "translate(40 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2",
    transform: "translate(-40 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65137",
    "data-name": "Group 65137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5293",
    "data-name": "Rectangle 5293",
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65138",
    "data-name": "Group 65138",
    transform: "translate(2.304 1.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34301",
    "data-name": "Path 34301",
    d: "M17.6,23.87a.258.258,0,0,1-.15-.047l-2.761-1.84-2.765,1.84a.265.265,0,0,1-.276,0,.269.269,0,0,1-.14-.236V17.135a1.565,1.565,0,0,1,1.561-1.565h3.223a1.565,1.565,0,0,1,1.565,1.565V23.6a.269.269,0,0,1-.143.236A.261.261,0,0,1,17.6,23.87ZM14.69,21.392a.247.247,0,0,1,.147.047L17.343,23.1V17.135a1.031,1.031,0,0,0-1.028-1.028H13.093a1.028,1.028,0,0,0-1.049,1.028V23.1l2.507-1.647a.258.258,0,0,1,.14-.061Z",
    transform: "translate(-11.51 -13.307)",
    fill: "#484848",
    stroke: "#484848",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34302",
    "data-name": "Path 34302",
    d: "M24.915,17.55a.272.272,0,0,1-.147-.047l-1.3-.863a.269.269,0,1,1,.3-.444l.881.584V10.811a1.024,1.024,0,0,0-1.024-1.024H20.4a1.024,1.024,0,0,0-1,.777.27.27,0,0,1-.523-.132A1.565,1.565,0,0,1,20.4,9.25h3.223a1.565,1.565,0,0,1,1.561,1.561v6.47a.272.272,0,0,1-.14.236.276.276,0,0,1-.132.032Z",
    transform: "translate(-16.238 -9.25)",
    fill: "#484848",
    stroke: "#484848",
    strokeWidth: 0.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks1);
export default __webpack_public_path__ + "static/media/Bookmarks - 1.e1aff343084cdd9820165a17114b09c5.svg";
export { ForwardRef as ReactComponent };